import MyselfService from 'services/MyselfService';
import changeEquipped from './changeEquipped';

const service = new MyselfService();

/** ----------------------------------------------------------------------------
 * UNEQUIP QUALITY
 -----------------------------------------------------------------------------*/
export default function unequipQuality(qualityId: number) {
  return changeEquipped(service.unequipQuality)(qualityId);
}